export const required = value => !value ? 'This field is required' : undefined;



// WEBPACK FOOTER //
// ./utils/validators.js